<script setup lang="ts">
import { computed, ref, watch } from 'vue'

import { resolveReportImageUrl } from '../../../service/reportMediaUrl'

import { useI18n } from '@/shared/i18n'
import { PreviewImage } from '@/shared/ui/media'

const props = defineProps<{
  value: unknown
  alt: string
}>()

const { t } = useI18n()
const open = ref(false)
const failed = ref(false)
const src = computed(() => resolveReportImageUrl(props.value))

watch(src, () => {
  failed.value = false
  open.value = false
})
</script>

<template>
  <button
    v-if="src && !failed"
    type="button"
    class="report-media-cell inline-flex w-15 h-15 items-center justify-center overflow-hidden p-0 border border-border rounded-sm bg-surface cursor-zoom-in focus-visible:outline-[length:var(--ui-ring-width)] focus-visible:outline-solid focus-visible:outline-ring focus-visible:outline-offset-2"
    :aria-label="t('reports.table.openMediaPreview', { value: alt })"
    @click="open = true"
  >
    <img :src="src" :alt="alt" loading="lazy" @error="failed = true" />
  </button>
  <span v-else class="report-media-cell__unavailable text-muted text-[0.75rem]">
    {{ t('reports.table.mediaUnavailable') }}
  </span>
  <PreviewImage
    v-if="src && !failed"
    v-model="open"
    :src="src"
    :alt="alt"
    :rotate-left-label="t('reports.card.rotateLeft')"
    :rotate-right-label="t('reports.card.rotateRight')"
    :zoom-in-label="t('reports.card.zoomIn')"
    :zoom-out-label="t('reports.card.zoomOut')"
    :close-label="t('reports.actions.close')"
  />
</template>

<style scoped>
.report-media-cell img,
.report-media-cell__unavailable .report-media-cell img,
.report-media-cell img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
